class ExtendableProxy
	{
	constructor(object, handler)
		{
		return new Proxy(object, handler);
		}
	}

PF.EntityProxy = class EntityProxy extends ExtendableProxy
	{
	constructor(options, entity)
		{
		if (entity === undefined)
			{
			entity = new PF.Entity(options);
			}
		super(entity, {
			set: EntityProxy.setter
		});
		// this.entity = entity;
		}

	static setter(target, key, value, receiver)
		{
		if (!PF.H.isSame(target[key], value))
			{
			target.trigger('beforeChangeProperty', key, target[key], value);
			// receiver.trigger('beforeChange:' + key, target[key], value, key);
			target[key] = value;
			// receiver.trigger('change:' + key, value);
			target.trigger('changeProperty', key, value);
			}
		return true;
		}
	};
